import { render, staticRenderFns } from "./vip-goods.vue?vue&type=template&id=248751d3"
import script from "./vip-goods.vue?vue&type=script&lang=js"
export * from "./vip-goods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports